export const NotificationType = Object.freeze({
  InsertionOrderBalanceDepletedEvent: 119,
  InsertionOrderExpiredEvent: 125,
  InsertionOrderExpiringUrgentEvent: 355,
  InsertionOrderExhaustingUrgentEvent: 354,
});
